import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryDirectors() {
  const { quoteService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(['quote-directors'], () =>
    quoteService.getQuoteDirectors()
  );

  return { directors: data ?? [], isLoading, isFetching } as const;
}
